module.exports = __webpack_public_path__ + "media/fonts/icomoon-1108baff.woff";